<div *ngIf="homeComponent">
  <ng-container *ngComponentOutlet="homeComponent"></ng-container>
</div>
